import { observer } from 'mobx-react';
import { helpCenterStore } from '../../../../../lib/store/ui/help-center';
import { TEXT } from '../../../../../lib/utils/text';
import { LINK } from '../../../../../shared/util/link';
import { iconSizeSmall } from '../../../../../styles/variables.module.scss';
import { RawAnchor } from '../../../../anchor';
import { LinkButton } from '../../../../button/link';
import { Help } from '../../../../icons/help';
import { Desktop, Mobile } from '../../../../responsive';
export const HelpCenterAction = observer(() => <>
        <Mobile>
            <RawAnchor href={LINK.help(helpCenterStore.screen)} target='_blank' analyticsKey='kyc.help'>
                <Help width={iconSizeSmall} />
            </RawAnchor>
        </Mobile>
        <Desktop>
            <LinkButton href={LINK.help(helpCenterStore.screen)} preset='secondary' size='medium' target='_blank' analyticsKey='kyc.help'>
                {TEXT.help}
            </LinkButton>
        </Desktop>
    </>);
export default HelpCenterAction;